export default __webpack_public_path__ + "e01ac2e6ed7b515b5de610346cb7367b.webp";